<template>
  <div id="mapContainer">
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 2412.2 1846.5" style="enable-background:new 0 0 2412.2 1846.5;" xml:space="preserve" id="map">
<image style="overflow:visible;enable-background:new;" width="10204" height="7811" xlink:href="../../static/map_lowerr.jpg"  transform="matrix(0.2364 0 0 0.2364 0 0)">
</image>
<g id="allRoads">
    <path id="Layer1" class="st0" d="M400.2,1422c-25.3,0.6-40-24.4-46.2-45.9c-1.4-4.7-2.4-9.7-2.3-14.6c0.1-4.7-1.2-8.6-2-13
        c-1-5.6-3.9-10.6-3.7-16.4c0.1-1.4,0.3-2.9-0.1-4.3c-1.1-4.7-5.5-9.1-8.1-13c-0.7-1-1.5-2.1-2.4-2.9c-5.4-4.7-3.7-11.4-7.8-16.5
        c-0.4-0.5-0.8-1-0.8-1.6c0-0.7,0.7-1.2,1.3-1.6c3.3-2.3,6.8-4.6,10.7-5.4c0.6-0.1,1.2-0.2,1.7,0.1c0.4,0.3,0.7,0.7,1.1,1
        c0.8,0.5,1.9-0.1,2.3-0.9c0.7-1.4-0.2-2.6,0.1-3.9c0.2-1.1,0.9-1.4,1.2-2.3c1-3.1,1.4-6.4,1.9-9.7c1-6.6,1.4-13.3,2-19.9
        c0.2-2.5,0.4-4.9,0.6-7.4c1-21,19-35,27.8-53"/>
    <path id="Layer2" class="st0" d="M377.6,1191c1.2,0.9,2.1,1.7,3.3,2.6c0.1,0,0.1,0.2,0,0.3s-0.3-0.1-0.3-0.2
        c-0.6-0.9,0.8,1.3,0.2,0.4c2.6,4.3,3.9,5.8,9.2,6c1.8,0.1,5.7,0.9,6.7,2.7c0.5,0.9,0.7,1.9,1.2,2.8c1.9,3.7,8,3.6,11.6,3.1
        c1-0.2,2-0.4,3-0.3c1.1,0.1,1.9,0.7,1.8,1.7c2.5,1.5,4.7,2.1,7.2,3.6c0.6,0.4,1.2,0.7,1.5,1.3c0.4,0.7,0.3,1.5,0.5,2.3
        c0.5,2.7,3,4.4,5.4,5.9c3.6,2.2,7.1,4.4,10.7,6.6c2.3,1.4,4.9,2.9,7.6,2.2c2.1-0.6,3.5,1.8,5,3.3c5.9,6.1,12.3,11.8,19.2,16.7
        c1.6,1.1,3.2,2.2,5,2.7c1.1,0.3,2.4,0.4,3.5,0.8c5.4,2,5.7,10.1,10.4,13.4c1.1-0.5,2.2-0.2,3,0.7c0.9,0.9,1.5,2,2.5,2.7
        c1,0.8,2.2,1.2,3.4,1.5c3.6,1.1,7.1,2.1,10.7,2.9c5.2,1.1,10.5,1.7,15.8,1.3c1.8-0.1,3.5-0.4,5.3-0.4c1.5,0,4.2,0.9,5.6,0.4
        c2.1-0.8,2.4-2.8,5-2.8c1.2,0,2.5,0.2,3.7,0.2c1,0,1.9-0.2,2.9-0.3c2.1-0.3,5-1.2,7.2-0.6c4.1,1.2,8.5-0.3,11.9-2.8
        c3.4-2.6,5.8-6.1,8-9.7c0.2-0.3-0.5-0.1-0.5,0.3"/>
    <path id="Layer3" class="st0" d="M574.1,1261c-2.6,5.8-5.9,11.2-8.6,17c-2.5,5.2-4.5,10.8-5.1,16.5c-0.5,4.9,0,9.9-0.2,14.8
        c-0.1,1.8-0.7,4.9,0.2,6.5c0.4,0.7,1,1.3,1.2,2c0.1,0.3,0.1,0.6,0,0.9c-0.3,0.6-1.1,0.5-1.8,0.4c-3.8-0.7-6.8,1.1-10.5,1.1
        c-1.8,0-3.6-0.9-5.2-0.3c-0.7,1.5,0.4,3.2,1.5,4.4c1.9,2.2,3.7,4.4,5.6,6.5"/>
    <path id="Layer4" class="st0" d="M549.9,1330.3c-0.4-0.8-1-2-2.1-3.2c-0.9-1-1.3-1.1-2.2-2c-1.5-1.4-3.6-4.1-2.9-5.2
        c0.2-0.4,0.7-0.4,4.8-0.1s5,0.5,6.9,0.3c1.8-0.2,3.1-0.6,5-0.5c0.8,0.1,1.7,0,2.1-0.7c0.5-1-0.8-1.8-0.9-2.7
        c-0.1-0.7,0.2-1.3,0.2-2c0.1-2.2,0.2-4.2,0.6-6.3c0.6-2.8,0.9-3-1.8-3.3c-3.1-0.2-3.7-0.6-4.2-0.1c-1,0.8-0.4,3.2-0.1,3.9"/>
    <path id="Layer5" class="st0" d="M554.8,1308.5c-0.6-1.2-1.1-2.8-0.6-3.4c0.3-0.3,0.9-0.2,1.8,0c1.1,0.2,4.6,0.8,5.6-0.4
        c0.4-0.5,0.2-1.3-0.3-3.4c-0.7-3.1-1.1-4.7-1.1-5.6c-0.2-3.6,1.9-8.3,2.8-10.5c0.1-0.3,0.5-1.1,0.1-1.7s-1.2-0.5-2.4-0.8
        c-2-0.5-3.4-1.8-3.8-2.2c-1.5-1.5-1-2.4-2.4-3.4c-1.2-0.9-2-0.5-3.4-1.3s-2.1-2.1-2.5-3.1"/>
    <path id="Layer6" class="st0" d="M550.3,1272.4c-1.7,0.6-3.1,1.1-4.2,1.3c-1.9,0.5-2.6,0.5-3,0.5c-1.7,0-1.8-0.5-2.8-0.3
        c-1.8,0.4-1.7,2.3-3.5,2.8c-1.5,0.4-2-0.8-3.6-0.4c-1.1,0.3-1.4,1.1-2.6,2c-1.4,1.1-2.4,1.1-4.6,1.8c-3.1,0.9-2.4,1.2-8.2,3.6
        c-3.6,1.5-3.7,1.3-5.4,2.2c-2.3,1.2-4.2,2.3-5.6,4.4c-1.3,2-0.8,2.8-1.8,5c-1.1,2.2-2.7,3.6-5.6,5.6c-4.7,3.2-7.6,4.3-12,6.6
        c-5.1,2.7-4.1,2.7-11.8,7c-5.9,3.3-8.9,5-11.8,6.2c-7.2,3-9.6,2.5-13.8,5.8c-1.3,1.1-2.4,2.1-4.6,3.2c-3,1.5-4.4,1.1-7.6,2
        c-1.6,0.5-4.2,1.9-9.4,4.8c-2.5,1.4-5,2.3-7.5,3.4c-2.3,1-3.1,2.8-3.8,5.1c-2,6.7-3.6,12.7-4.8,19.7c-0.1,0.8-0.3,1.7-0.7,2.4
        c-0.4,0.8-1.1,1.4-1.7,2c-4.3,4-8,8.6-12.7,12.1c-2.7,2-5.8,3.2-8.6,4.9c-3.2,2-5.3,5.2-8.1,7.7c-2.8,2.4-6.4,4-8.7,6.9
        c-3.7,4.6-7.2,9.1-11.5,13.2c-2.1,2-3.5,4.6-4.8,7.2c-1.2,2.4-2,5.2-3.4,7.4c-1.6,2.5-4.3,4.6-6.2,6.9c-2.5,3-5,5.9-7.5,8.9
        c-1.6,1.9-3.3,3.9-5.6,5.1c-0.9,0.5-2,0.9-2.6,1.8c-0.9,1.4-0.2,3.2,0.2,4.8c0.7,2.5,0.7,5.1,0.8,7.7c0,3.5,0.1,7,0.1,10.4
        c-1.5,1.1-3.5,1.6-5.4,1.8c-2.4,0.3-4.9,0.4-7.3,0.1c-1-0.1-2-0.3-2.9-0.1c-0.8,0.1-1.6,0.5-2.4,0.7c-3.3,0.7-6.7-1.8-10.1-1.2
        c-0.4,0.1-0.8,0.2-1,0.6s0.1,0.9,0.5,0.8c0.1,4-0.9,7-2.1,10.8c-0.4,1.2-0.8,2.4-0.6,3.6c0.2,1.2,0.9,2.3,1.3,3.4
        c1.1,3.5-1.3,7.1-2.2,10.6c-1,4.2,0.3,8.5,0.6,12.7c0.7,8.2-1.8,16.3-4.4,24.1c2,1.7,3.5,3.2,5.8,4.3c2.5,1.2,5.2,2.1,7.9,2.8
        c5.4,1.6,11.2,2.8,16.7,1.2c-0.9,3.4-1.7,6.8-2,10.3s0.2,7.1,1.9,10.2c1.1,2.1,2.8,3.9,3.5,6.1c0.6,1.9,0.6,4,1.6,5.7
        c0.6,1,1.5,1.7,2.4,2.5c2.7,2.4,5.1,5.2,6.7,8.4c0.8,1.6,1.4,3.4,2,5.1c1.1,3.4,2.2,6.9,2.1,10.4"/>
    <path id="Layer7" class="st0" d="M344.3,1609.8c-0.7-8.2-1.9-17.4-8.6-22.2c-1.2-0.9-2.6-1.6-3.7-2.7c-1.8-2-2.1-4.9-2.9-7.4
        c-0.7-2.3-2-4.4-2.9-6.6c-2.7-6.4-2.7-13.8,0-20.2c-9.7-0.4-19.7-3.1-28-8.1c-0.6-0.3-1.2-0.7-1.4-1.3c-0.2-0.5-0.1-1,0-1.5
        c0.8-5.9,1.6-11.8,2.4-17.7c0.2-1.8,0.5-3.7,0-5.5c-0.4-1.4-1.2-2.6-1.6-3.9c-1.3-4,0.4-8.3,2.5-11.9c0.5-0.9,1.1-1.8,1.1-2.8
        c0.1-1-0.3-1.9-0.6-2.9c-1.4-5.9,3.4-11.9,1.8-17.7"/>
    <path id="Layer8" class="st0" d="M303.2,1476.6c4.1,0.3,7.7,0.9,11.6-0.6c3.8-1.5,4.7-0.7,8.1,0.7c2.6,1.1,6.4-2.4,8.1,0
        c1.4,2-0.8,8.9,0.2,9.7"/>
    <path id="Layer9" class="st0" d="M329.8,1487.1c2.2-3.1,1.2-7.1,1.2-10.1c-1.4-1.6-5.2-1-7.1-0.7c-2.7,0.3-5.6-1.6-8.2-0.8
        c-1.4,0.4-2.5,1.8-3.9,1.9c-1.3,0.1-2.8-0.8-4.1-1c-1.6-0.3-3.1-0.3-4.7-0.7"/>
    <path id="Layer10" class="st0" d="M302.5,1476c2.8,0.2,5.5,0.3,8.3,0.5c0.6,0,1.3,0.1,1.8-0.1c0.7-0.2,1.2-0.7,1.8-1
        c1.9-1,4.2-0.4,6.3,0c2.5,0.5,5.1,0.6,7.6,0.5c1.5-0.1,3.2-0.5,3.7-1.8c0.3-0.6,0.2-1.3,0.2-1.9c-0.4-4.8-0.8-9.6-1.3-14.4
        c-0.1-0.7-0.1-1.4-0.5-1.9c-0.3-0.4-0.6-0.7-0.7-1.1s0.1-0.8,0.3-1.2c0.5-1,1.1-1.9,1.9-2.7"/>
    <path id="Layer11" class="st0" d="M331.7,1451.8c-7-1.9-14-3.9-20.9-5.8l0,0c0.4-1.3,0.9-3,1.4-5.1c0.4-1.4,1.4-5.7,2.4-12
        c0.9-5.5,1.3-8.3,1.4-11.3c0-4.7-0.7-5-0.7-8.9c-0.1-7.5,2.5-7.8,3.1-15.4c0.6-8.3-2.4-9.1-0.7-15.1c0.6-2.1,1.8-4.7,0.7-7.6
        c-0.7-1.8-1.6-1.9-2.4-3.8c-1-2.2-0.6-3.8,0-8.6c0.7-5.9,1-8.9,0.3-10.6c-1.2-3.1-3-2.4-5.1-5.8c-2.1-3.5-1.1-5.3-2.7-12
        c-0.8-3.2-1.4-5.9-3.1-8.9c-3.4-6.1-6.9-6-8.9-10.6c-1.4-3.1-0.8-6.4,0.3-13c1.6-9.4,4.5-18.5,4.5-18.5c0.7-2.3,1.6-5,0.7-7.9
        c-0.7-2.3-1.9-2.7-2.1-4.8c-0.2-2.9,2-4,1.4-6.2c-0.4-1.4-1.4-1.5-3.1-3.4c-1.4-1.7-2-3.2-2.7-5.1c-2.1-5.6-1.3-7.7-3.1-13.7
        c-1.9-6.4-3.6-6.1-4.1-11c-0.2-2.1-0.1-4.2-1.4-4.8c-0.5-0.3-1.4-0.3-4.8,1.7c-4.4,2.6-4.9,3.9-6.9,4.5c-1.5,0.5-4,0.5-7.6-1.7"/>
    <path id="Layer12" class="st0" d="M269.1,1227.3c-2.6-1.5-4.8-2-6.3-2.3c-2.4-0.3-4.7-0.1-7.1,0.2c-1.1,0.1-2,0.3-2.6,0.4"/>
    <path id="Layer13" class="st0" d="M241,1216.4c0,1.1,0.6,2.2,1.3,3c0.7,0.9,1.6,1.6,2.1,2.6c0.2,0.4,0.4,0.8,0.7,1.1
        c0.6,0.8,1.7,1.2,2.7,1.5c1.7,0.5,3.5,0.7,5.3,0.7"/>
    <path id="Layer14" class="st0" d="M240.6,1217.4c0.2-2.2,0.8-6.7,4-11.3c2.6-3.8,5.5-3,12-8.8c2-1.8,2.7-2.7,4.8-4.1
        c3-2,4.1-1.9,6.7-4c2.2-1.8,3.7-3.7,4-4c1.8-2.3,1.5-2.7,2.8-3.8c2.5-2.2,4.9-1.4,5.5-3c0.5-1.2-0.8-2.1-1.9-5.1
        c-0.9-2.5-0.4-3.1-1.1-6.1c-0.8-3.9-1.9-4.1-3.6-9.1c-1.4-4-0.7-3.8-1.9-7.2c-1.4-3.7-3.1-6.4-4.7-8.7c-1.4-2-2.7-4-4.9-6.4
        c-3.3-3.5-5-4.1-5.3-6.4c-0.2-2,1-2.3,1.1-5.1c0-2.2-0.8-2.6-1.5-5.5c-0.2-1-1-4.3-0.2-8.1c0.7-3.4,1.9-3.5,1.9-6.1
        c0-3.3-1.9-5.8-2.1-6.1c-1.6-2.1-2.8-1.9-3.8-4c-0.4-0.8-0.3-1-0.8-4.2c-0.8-4.6-1.2-5.2-0.9-6.9c0.2-1.7,1.1-2,1.4-3.9
        c0.2-1.5-0.4-1.6-0.3-3.4s0.9-3.1,1.4-3.9c0.8-1.4,1.2-4,1.9-9c0.2-1.3,0.6-4.1,1.7-14.3c0.4-3.9,0.6-5.7,2-7.3
        c0.5-0.6,1.4-1.4,1.7-2.7c0.3-1.5-0.5-1.9-0.2-3.2c0.4-1.7,1.7-1.7,2.4-3.4c0.8-2-0.5-3.5,0.2-4.1c0.8-0.8,3,2.2,7.3,3.2
        c1.8,0.4,3.6,0.5,3.6,0.5c1.5,0.1,1.7-0.1,2.7,0c2,0.2,2.5,0.9,4.4,1.5c2.6,0.8,2.8-0.3,5.6,0.3c3.1,0.7,3.9,2.1,5.3,1.5
        s1.2-2.1,2.7-2.6c1-0.3,1.4,0.4,2.9,0.2c0.8-0.1,1.1-0.3,2.6-1c2.2-1.1,2.3-1,3.4-1.5c1.5-0.7,2-1.3,4.4-3.1
        c3.1-2.3,4.6-3.4,5.8-3.9c1.6-0.7,2.5-0.6,5.6-1c2.1-0.2,5-0.7,8.7-1.4"/>
    <path id="Layer15" class="st0" d="M325.8,1019.6c-0.3,0.2-0.4,0.7-0.7,1.1c-0.3,0.4-0.7,0.6-1,0.9c-0.2,0.2-0.4,0.5-0.7,0.8
        c-0.7,0.6-1.7,0.5-2.5,0.4c-0.9-0.1-1.6,0-2.6,0.1c-1.8,0.3-3.7,0.2-5.4,0.8c-1.5,0.5-2.7,1.8-3.9,2.8c-2.6,2-5.5,3.8-8.6,5.1
        c-1.2,0.5-2.1,0.5-1.8,2.1c0.2,1.1,0.7,2.7,1.8,3.1c1.1,0.5,2.4,0.2,3.5,0.4c5,0.9,7.9,7.2,8.1,7.7c0.9,2.1,0.7,4.2,1.3,6.3
        c0.4,1.7,2.4,4.2,4,4.9c0.8,0.4,1.8,0.4,2.5,1c0.6,0.5,0.9,1.4,1.1,2.2c0.2,0.8,0.5,1.6,0.6,2.5c0.2,0.7,0,1.2,0.1,1.9
        c0.3,1.4,1.6,2.2,1.8,3.8c0.3,2.2-1,2.8-1.4,5.3c-0.6,3.6,1.1,7.6,3.5,9.8c2.2,2,3.2,1.1,4.9,3.2c2.2,2.6,1.4,5.2,3.5,6.3
        c1.4,0.7,2.1-0.3,3.9,0.4c2.3,0.9,1.9,3,4.6,4.9c2.1,1.5,3.1,0.8,4.9,2.5c1.7,1.5,2.2,3.3,2.5,4.2c0.9,2.8,6.1,8.5,16.5,19.7
        c1.4,1.6,2.6,2.8,4.6,3.9c3.5,1.9,5.1,0.9,8.1,2.5c3.4,1.7,2.4,3.6,6.3,7c4.7,4.2,8.9,4.1,9.1,6.7c0.1,0.8-0.4,0.9-2.1,4.6
        c-1.2,2.5-1.1,2.6-2.1,4.9c-2.2,4.9-3,4.7-3.5,7c-0.7,3.2,0.1,6.7,1.4,7c1,0.2,1.5-1.7,3.9-2.8c1.6-0.7,2.1-0.2,5.6-0.4
        c3.7-0.2,4.4-0.8,8.4-1.1c1.8-0.1,3.3,0,4.2,0"/>
    <path id="Layer16" class="st0" d="M407.2,1162.8c1.7-0.7,4.2-1.4,7.1-1.4s3.6,0.6,6.1,0.3c3.2-0.4,3.8-1.6,7.1-2.3
        c2.7-0.5,3.9-0.1,6.8,0c3.3,0.1,5.2-0.4,11.6-1.9c13.4-3.1,11.3-2.1,14.8-3.2c7.8-2.5,12.5-4,16.7-8.4c2.1-2.1,4.4-5.4,5.5-4.8
        c0.7,0.4-0.1,2,1,3.9c1.1,2,2.7,1.6,4.2,3.9c0.9,1.4,0.4,1.7,1.3,3.2c1.2,2.1,2.5,2.3,5.2,4.5c3.7,3,4.2,5.1,5.5,4.8
        c1.3-0.3,1-2.5,2.6-4.8c2-3.1,4.4-2.3,10-5.5c1-0.6,1.8-1.3,2.7-1.9c2.5-1.9,6.9-6.6,10-6.6c1,0,1.9,0.3,2.8,0.5
        c2.9,0.6,5.3-0.5,8.1-0.8c2.6-0.3,5.7,0.2,8.2,0.7c1.1,0.2,2.3,0.6,3.3,1.2c5.5,3.9,6.1,11.3,10.5,15.9c1.5,1.6,3,3.2,5,3.9
        c2.8,1.1,5,0.2,7.7-0.1"/>
    <path id="Layer17" class="st0" d="M566.8,1165.5c0.9,0,2.3,0.2,3.9,0.8c1.9,0.7,2.3,1.4,3.7,1.6c1.9,0.3,2.6-0.9,4.7-1.3
        c2.2-0.5,3.4,0.4,6.8,1.3c4.4,1.2,4.9,0.4,9.4,1.3c5.5,1.1,4.9,2.4,9.7,3.4c3.6,0.8,4.5,0.2,14.1,0.5c1.8,0.1,3.7-0.2,6.3,0.3
        c2.8,0.5,2.9,1.2,5,1.3c2.1,0.2,2.4-0.5,7.3-1.6c2.9-0.6,2.9-0.4,5.5-1c2.9-0.7,3.3-1.1,5-1.3c1.6-0.2,2.6-0.1,6,0.3
        c8,0.9,9.2,0.9,10.2,0c0.5-0.5,0.4-0.8,1.3-4.2c1.6-6.1,2-6.1,2.1-8.1c0.1-3.9-1.6-4-1-6.8c0.7-3.1,3-3.7,2.9-6.5
        c0-1.4-0.6-1.3-1.3-3.7c-0.3-1-1.9-6.2,0.3-8.1c0.6-0.5,1.4-0.6,3.1-0.8c3.1-0.3,5.4-0.6,7.3,0.8c0.8,0.6,1.6,2,3.1,5
        c1.2,2.2,1.7,3.3,2.1,4.4c1.1,3.5,0,4.3,1,6.3c1.1,2.1,2.4,1.5,5.5,4.2s2.6,4.2,5,5.5c2.4,1.4,3.2,0,7.1,1c1.3,0.3,6.4,1.7,8.9,5.8
        c1.1,1.8,0.9,2.8,2.1,3.4c2.3,1.2,4.6-1.8,6.8-0.8c1.7,0.7,1.2,2.8,3.1,7.1c1.2,2.6,2.5,5.5,5,6.8c3.8,2,8.6-0.3,9.9-1"/>
    <path id="Layer18" class="st0" d="M737.2,1181.3c-1.3,0-2.5,0-3.7,0.3c-0.5,0.1-0.9,0.3-1.4,0.4c-0.7,0.1-1.4,0.1-2.1,0
        c-1.2-0.1-2.4-0.4-3.6-0.7c-1.9-0.5-2.2-4.4-3-6c-2.4-5.3-4.7-5.6-4.5-8.1c0.2-3,3.6-3.5,4.5-7.8c0.3-1.6,0.2-3,0-3.9"/>
    <path id="Layer19" class="st0" d="M723.3,1155.6c0.2,0.8,0.5,2.9-0.4,5.3c-0.9,2.2-2.3,2.1-3.1,3.9s0,3,2.8,10.6
        c0.6,1.6,1.2,4.9,2.7,5.9c2.2,1.5,7.8,0.6,10.3,0.2c0.4-0.1,0.7-0.2,1-0.4c0.2-0.2,0.3-0.5,0.3-0.7c0.7-2.5,1.5-5.1,3.6-6.7
        c1-0.8,2-1.1,2.3-2.5c0.2-1.2-0.4-2.6-0.1-3.9c0.3-1.7,1.1-2.9,1.6-3.7"/>
    <path id="Layer20" class="st0" d="M744.2,1166.5c0.6,5.4-0.6,7.8-1.8,9c-0.8,0.7-2.2,1.5-3.4,3.4c-0.9,1.4-0.7,1.8-1.3,2.6
        c-1.8,2.4-6.7,3.2-10,1.3c-1.4-0.7-2.2-2.1-4-4.8c-2.8-4.3-4.2-6.4-3.7-8.7c0.5-2.3,2.2-2.5,3.5-5.4c1.1-2.5,0.9-5,0.6-6.7"/>
    <path id="Layer21" class="st0" d="M722.7,1155.5c0.8,2.5,0.5,4.2,0.2,5.3c-0.9,2.7-3.2,3.4-3.6,6.1c-0.1,0.9,0,1.7,0.4,3.3
        c0.7,2.9,1.7,7.6,5.7,10.1c0.6,0.3,1.1,0.8,1.8,0.9c3.4,0.2,6.8,0.1,10.2-0.3"/>
    <path id="Layer22" class="st0" d="M736.3,1181.9c0.4-1.5,1.3-4.6,4.1-6.4c2.2-1.4,4.5-1.4,7.6-1.4c6.3,0.1,8.9,2.2,10.9,0.5
        c0.5-0.4,0.9-1,1.3-4.7c0.8-6.7,0-7.7,0.8-12.2c0.1-0.8,0.9-3.4,2.3-8.6c0.7-2.5,0.9-3.1,1.4-3.9c1.8-2.8,4.8-3.4,7.7-4.5
        c8.8-3.2,7.4-7.2,16.2-10.2c3.6-1.2,5.6-1.1,7.4-3.3c2.1-2.5,1.5-5.1,3.7-6.4c1.5-0.9,2.8-0.3,6,0c5.2,0.5,7.2-1.8,9-0.4
        c1.3,1,0.6,2.3,2,3.3c1.8,1.3,3.4-0.2,6,1.1c1.4,0.7,1,1.1,2.8,2.3c2.7,1.8,4,1,5.8,2.6c2,1.7,1.6,3.8,2.6,3.9
        c1.3,0.1,3.1-3.7,3-7.3c0-1.3-0.3-1.8-0.2-3.4c0.1-1.9,0.6-2.7,1.1-4.3c1.3-4.6-0.6-6.7,1.1-8.8c0.7-0.9,1.5-1.1,3-1.7
        c3.2-1.4,5.7-3.6,10.5-7.9c5.9-5.3,5.9-6.7,5.8-7.3c-0.2-1.2-1-1.6-3.6-4.1c-4.8-4.4-7.2-6.6-7.1-8.8c0.1-1.7,1.6-2.9,3.9-4.7
        c3.5-2.8,5.6-2.4,7.7-5.2c1.2-1.5,1.8-3.1,1.9-3.6c1.1-3,0.4-4.5,1.7-5.8c1.2-1.2,2.4-0.5,3.2-1.7c1-1.4-0.3-2.5,0.6-4.3
        c0.8-1.6,2.1-1.3,2.6-2.8c0.3-0.9,0-1.5-0.7-3.4c-0.2-0.7-1-3.2-1.3-4.5c-0.7-3.5,1.2-4.7,1.3-9c0-2-0.4-2.6-0.9-5.4
        c-0.8-4.4-2.1-10,0.2-14.1c2.2-4,12.2-0.4,15.5,1c5,2.1,10.4,2.5,15.7,3.3c6,0.9,12.1,1.6,18.1,2.3c0.4-2.3,0.4-4.7,0-7
        c-0.4-2.4,2.1-3.7,2.4-5.8c0.1-0.7-0.1-1.5,0.2-2.3c0.5-1.2,1.7-2.3,2.2-3.4c0.5-1.2,0.7-2.3,1-3.6c0.6-2.4,1.2-4.8,1.9-7.1
        c1.3-4.5,2.8-9,4.2-13.4c1.1-3.3,3.2-6.5,4.8-9.7c1.7-3.3,3.4-6.7,5-10c0.4-0.7,0.7-1.4,0.8-2.2c0.3-2.2-0.6-4.6-0.7-6.7
        c-0.2-2.9,0.4-5.7,0.2-8.6c-0.2-2.9-1.2-5.7-1-8.6c0.1-1.1,0.4-2.2,0.1-3.3c-0.3-0.9-0.9-1.6-1.3-2.4c-1-2-0.2-4.3-0.3-6.4
        c-0.1-2.3,0.8-4.4,1-6.7c0.2-2.9-1.8-3-3.9-4.2c-1.3-0.8-2-2.2-2.7-3.6c-0.4-1-0.9-1.9-1.3-2.9c-2.1-4.4-2.1-9.4-2.7-14.2
        c-0.6-5.1-2.8-10-4.9-14.6c-1-2.3-2.2-4.8-4.5-6"/>
    <path id="Layer23" class="st0" d="M918.8,869.2c3.5,4.3,4.9,9.2,6.3,14.4c1.2,4.4-2,8.1-0.5,12.3c0.9,2.4,3.5,3.6,4.1,6.5
        c0.1,0.7,0.2,1.4,0.6,2c0.6,1.1,12.4,0.9,14.3,1.3"/>
    <path id="Layer24" class="st0" d="M943.4,906.6c-5.5-1.4-9.3-1.2-11.6-0.9c-0.6,0.1-2.2,0.3-2.3,0.9c-0.1,0.7,2.2,1.2,5,3.4
        c1.9,1.5,3.2,3.6,2.5,6.1c-0.3,1-0.9,1.9-1.2,2.9c-0.8,2.5,0,6.7,0.8,9.2c1.2,3.8,1.1,7.3,1.7,11.2c-0.2-1.1,2.5-3.2,3.3-3.7
        c1.5-0.9,3-0.7,4.7-0.7c3.4,0,7.4,0.5,10.2-1.9c1.2-1,1.4-1.9,2.8-2c1.4-0.2,3,0.7,4.4,0.7c1.5,0,3-0.5,4.5-0.4
        c1.4,0.1,2.8,0.6,4.2,0.6c3.7-0.1,5.5-4.2,8.8-5.2c2.5-0.8,6.4-0.1,9-0.2c0.3,0,0.5,0,0.8-0.1s0.6-0.5,0.9-0.7
        c0.6-0.6,1.3-1.1,2-1.5c1.8-1.2,3.6-2.3,5.4-3.5c0.5-0.3,1-0.6,1.3-1.1c2.1-2.9,0.6-6.9-0.1-9.9c-1.1-4.7-0.7-8.5-0.5-10.5
        c0.4-3.1,1.4-6,3.4-11.9c0.6-1.8,1.2-3.3,1.6-4.3"/>
    <path id="Layer25" class="st0" d="M1004.8,884.1c-1.9,3.5-3,6.8-3.6,9.4c-1.4,6.3-0.9,12.1-0.6,14.3c0.7,6.2,2.2,7.6,0.9,10.2
        c-1.3,2.6-3.1,2.2-5.9,6.2c-1.1,1.6-3,4.4-2.2,6.8c0.5,1.4,1.4,1.4,2.2,3.1c0.7,1.4,0.6,2.6,0.3,5.9c-0.6,7-0.9,7.5-0.3,8.4
        c1.5,2,4.3,0.8,5.9,3.1c0.7,1,0.7,2.3,0.6,5c0,1.6-0.2,3.7-0.9,6.2c-0.2,0.6-0.8,2.6-2.2,5.3c-2.2,4.1-3.1,3.9-4.3,6.5
        c-1.5,3.4-2,8.4,0.3,10.5c1,1,1.5,0.3,4.3,1.5c2.9,1.3,2.9,2.3,5.6,3.4c2.8,1.2,3.6,0.5,4.6,1.5c1.6,1.6,0.4,4.1,0,8.4
        c-0.6,6.5,1,12,2.2,15.8c1,3.4,1.3,2.8,2.8,7.4c1.9,5.8,1.6,6.9,3.1,11.8c2,6.3,3.6,11.6,7.1,12.4c1.8,0.4,3.5-1,5.1-1.6
        c3.3-1.1,5.5-0.3,8.8,0.5c2.9,0.7,5.9-0.1,8.7-0.8c9.3-2.4,18.5-5.1,28.1-5.7c6.7-0.4,12.9,0.1,19.2,2.3c2.4,0.8,4.8,1.7,7.3,2.3
        c5.3,1.2,10.7,1.1,16.2,1c3.2-0.1,6.3-0.1,9.5-0.2c1.5,0,2.9-0.1,4.3-0.4c1-0.2,2-0.6,3-0.7c3.5-0.6,7.8,1,10.3-1.6
        c4.5-4.7,12.6-4.1,19-4.9c3.6-0.4,7.3-0.7,10.4-2.3c3.6-1.9,6-5.3,8.9-8.1c1.9-1.8,4.1-3.4,6.4-4.7"/>
    <path id="Layer26" class="st0" d="M1189.7,1021.9c0.8,0.1,2.6,0.3,4.4,1.6c2,1.5,2.3,3.7,3.2,5.6c1,2.2,3.8,6.5,6.5,6.7
        c5.3,0.4,9.4-6,14.1-7.5c3.7-1.2,7.9,0,11.5,0.9c3,0.7,4.7,2.8,7.7,3.3c9.4,1.7,18.2,1.4,27.5,2.5c3.8,0.5,7.9,0.7,11.6,1.6
        c3.1,0.8,5.9,4.2,9.3,2.3c0.5,3.4,3.1,6.5,6.1,8c3.1,1.5,7.1,1.6,10.5,2.1c4.3,0.7,5.5,1.5,8.4,2.1c4.5,1,10.3,0.3,18.7-1.1
        c2.4-0.4,6.2-1.1,7.3-1.4c3.3-0.6,3.9-0.5,5.3-1.1c2.8-1.2,2.8-2.6,5.6-3.9c2.1-1,4.1-1,6-1.1c4-0.1,5.4,0.9,8.2,1.3
        c5.4,0.7,5.9-2.3,14-3.7c3.8-0.7,7.7-1.2,11.5-0.9c1.6,0.1,4,0.3,5.1,1.8c1.7,2.3-0.7,6.2-1.3,8.5c-0.6,2.2-0.7,4.6-0.8,6.9
        c-0.1,3.1-0.2,6.1,0,9.2c0.2,1.9,0.5,3.8,0.7,5.8c0.2,1.8,0.2,3.6,0.2,5.4c0,3.5-0.2,6.9-0.6,10.4c-0.2,2.1-0.6,4.4-2.1,5.8
        c-2.4,2.4-6.6,2.3-7.9,5.9c-0.7,1.9-0.3,4.1,0.1,6.2c0.3,1.7,0.7,3.3,1.3,4.9c0.3,0.6,0.6,1.3,0.6,2c0.2,1.3-0.4,2.6-0.3,3.8
        c0.6,4.9,8.8,2,9.5,6.1c0.2,1,0.1,2,0.3,3c0.3,1.2,1.1,2.2,1.6,3.3c0.5,1,0.8,2.2,1.1,3.3c0.8,3,1.5,6,2.1,9.1
        c0.3,1.6,0.7,3.3,2,4.3c0.9,0.6,1.9,0.7,2.9,1.1c1.1,0.4,1.6,1.2,2.6,1.7c2.4,1.3,6-0.4,6.9,2.8c0.5,1.9,1.6,3.6,3,5
        c3.5,3.3,9.7,2.3,14,4.5c3.8,1.9,3.7,3.4,7.4,4.8c3.3,1.2,3.9,0.3,7.9,1.2c4,0.9,6.8,2.7,11.2,5.5c1.8,1.1,3.4,2.5,5.2,3.7
        c2,1.4,4.1,1.7,5.8,3.6c0.5,0.6,1,1.3,1.6,1.9c3,3.4,6.4,4,10.5,5c1.5,0.4,3.8,0.8,5.1,1.5c1.5,0.8,2.2,2.9,2.8,4.5
        c1.5,3.6,2.6,7.7,5.8,10.2c2,1.5,4.5,1.7,6.5,3c1.8,1.2,2.2,4.2,2,6.3c-0.1,1.4-0.6,2.8-0.8,4.3c-0.4,3.5,1,7.1,3.7,9.4
        c2.2,1.9,5.2,2.8,7.3,4.8c1.2,1.2,2.1,2.6,3.3,3.8c1.7,1.6,5.1,1.8,7.2,2.6c3,1.1,7.2,0.6,10.3,0.7c2.5,0.1,5,0.2,7.3-0.5
        c1.9-0.6,2-0.1,3.4,0.6c1.5,0.8,2.8,1.5,4.6,2.1c2.2,0.8,3.7,2.8,5.1,4.6c4.8,6.2,10.1,12,15.7,17.5c1,1,2.1,2.1,2.8,3.4
        c0.5,1.1,0.8,2.3,1.1,3.4c1.2,4.2,3.5,8.1,6.7,11.1c1.3,1.2,2.7,2.3,3.8,3.7c0.9,1.3,1.6,2.7,2.2,4.1c3.6,7.6,10.6,16.9,18.7,20.1
        c3.1,1.2,6,3,8.5,5.3c2.9,2.6,8,1.8,11.8,2.7c0.7,0.2,1.6,0.3,2-0.3c0.2-0.2,0.2-0.4,0.3-0.6c0.6-1,1.9-1.2,3.1-1.3
        c7.8-0.8,15.6-2.3,23.1-4.6"/>
    <path id="Layer27" class="st0" d="M1650.8,1307.7c1.6,0,4,0,7.1,0c8.9-0.1,7.6-0.4,10-0.2c3.7,0.3,5.5,1,7.5-0.2
        c0.3-0.2,0.7-0.5,2.4-2.7c2.8-3.6,2.7-4.3,4.2-6c3.1-3.5,5.3-2.5,6.2-5.1c0.7-2-0.4-2.9,0.4-6.2c0.4-1.3,0.8-2.3,1.3-3.3
        c1.7-3.5,3.3-4.5,2.9-5.5c-0.4-1.1-2.4-1.1-4-1.3c-3.8-0.5-10.7-2.2-10.8-4c0-0.2,0-0.5,2.7-2.4c1.5-1.1,2.8-2,3.8-2.7"/>
    <path id="Layer28" class="st0" d="M1684.2,1270.5c-0.6,0.6-3.3,2.6-3.3,3.5c-0.1,2.3,8.3,3.7,9.9,4.1c1.3,0.3,2.7,0.5,4,0.7
        c3.3,0.5,5.6-0.6,8.8-1.3c1.4-0.3,2.8,0,4.2-0.4c1.6-0.4,3.2-0.8,4.9-1c3.9-0.4,7.9-0.4,11.8,0.1c0.5,0.1,1.1,0.1,1.5-0.1
        c0.5-0.3,0.7-0.9,0.9-1.4c0.6-2.2,0-3.8-0.1-5.8c-0.1-1.2,0.5-2.6,0.6-3.8c0.1-2.2-0.3-2.8-0.4-5.4c-0.1-2.4,0.2-2.6,0.3-5.3
        c0.2-5.5-1-5.8-0.3-8.4c0.8-2.8,2.1-2.3,3.3-5.7c0.6-1.7,0.3-2,1.2-7c0.5-3.1,0.6-2.8,0.9-4.9c0.8-5.2,0.1-5.1,0.9-8.1
        c0.7-2.6,1.5-3.8,1-5.8c-0.3-1.3-1-2.5-1.1-2.6c-0.8-1.2-1.7-1.9-1.9-2c-2.9-2.2-5.6-11.9-6-13.2c-2.2-8.2-3.4-12.3-3.7-16.2
        c-0.7-8.4,1.1-9.7,0.5-13.6c-0.1-0.4-0.3-1.7,0.4-2.3c0.5-0.4,1.3-0.1,3,0.1c1.8,0.2,4.6,0.6,5.9-0.8c1.2-1.4,3-2.3,4.1-3.7
        c0.5-0.7,0.9-1.5,1.3-2.3c0.4-0.7,1.4-2.7,2.2-3c1.1-0.4,1.3,0.8,1.6,1.8c0.9,2.5,0.8,4.3,1,4.3c0.3,0,0.7-2.4,1.2-5.3
        c0.8-4.7,1.8-8.3,1.6-13c-0.1-1.2,0.3-2.5,0.9-3.6c0.6-1,0.4-2.4,0.7-3.6c0.5-1.8,0.7-3.7,0.5-5.6c-0.2-1.3-0.9-2.4-0.9-3.7
        c-0.1-1.5,0.6-3.2,1.1-4.6c1.1-3.1,2.7-6.2,2.7-9.6c0-1.6-0.4-3.3-1.1-4.7c-0.4-0.9-1.2-1.4-1.6-2.2c-0.5-0.9-0.6-1.7-0.6-2.7
        c-0.2-2.5-0.1-5.1,0.1-7.6c0.2-1.6,0.4-3.3,1.1-4.8c0.9-1.8,2.3-3.3,3.7-4.8c1.8-1.8,3.6-3.7,5.6-5.3c0.8-0.7,1.7-1.3,2.4-2.2
        c0.7-0.8,1.3-1.9,2-2.7c1.7-2,4.4-3.1,7.1-2.9c1.1,0.1,1.5,0.3,2.2-0.6c0.6-0.7,0.8-2,0.7-2.9c0-0.4-0.2-0.8-0.4-1.1
        c-0.3-0.4-0.9-0.6-1.3-1c-0.7-0.6-0.6-1.3-0.7-2.1c-0.3-1.5-2.6-3.9-0.5-5c0.4-0.2,0.9-0.3,1.4-0.3c0.7,0,1.4,0,2.2,0.1
        c0.6,0.1,1.2,0.2,1.6-0.2c0.8-0.6,0.6-2.9,0.6-3.9c0.1-2.3-0.9-5.9,0.3-7.9c0.4-0.6,0.9-1.2,1.2-1.8c1.5-2.4,1.9-5.5,3-8.1
        c1.3-3.2,2.6-6.4,3.9-9.6c1.8-4.4,3.6-8.9,6.5-12.7c1-1.3,2-2.7,3.8-1.4c0.9,0.6,1.5,1.6,2.5,2.1c1.4,0.7,3.1,0.3,4.6-0.3
        c3.2-1.3,6.1-3.3,8.4-5.9c2.1-2.4,3.8-5.2,6.5-6.9c1.9-1.1,4.3-1.3,6.1-2.4c1.8-1.1,2.6-1.8,4.9-1.6c2.8,0.2,5.6,0.4,8.4,0.7
        c1.5,0.2,3,0.4,4.5,0.2s2.9-0.7,4.3-1.1c5-1.5,10.2-2.2,15.4-2c1.8,0.1,3.7,0.3,5.3-0.7c0.6-0.3,1.1-0.8,1.6-1.2
        c1.4-0.8,3.2-0.6,4.8-0.9c2.6-0.5,4.7-2.1,6.6-3.9c3.3-3.1,6.1-6.6,8.9-10.2c1.6-2,3.3-4.1,4.9-6.1c0.8-0.9,1.5-1.9,2.4-2.7
        c1.3-1.1,2.9-1.8,4.4-2.7c4.6-2.7,8.4-6.8,10.7-11.6c2-4.1,1.9-9.2,4.4-12.9c1.1-1.6,2.4-3.1,2.8-5c0.2-0.7,0.2-1.4,0.5-2.1
        c0.3-0.7,0.9-1.3,1.6-1.2c2.2,0,4.4-1.1,6.1-2.5c1.7-1.5,3-3.3,4.3-5.1c2.3-3.3,4.7-6.6,7-9.9c0.8-1.2,1.7-2.3,2.3-3.6
        c1-1.9,1.6-4.2,3.4-5.5c0.2-0.2,0.6,0.1,0.4,0.4s-0.6,0.1-0.6-0.1"/>
    <path id="Layer29" class="st0" d="M1938.1,909.5c-0.7,1.6-1.8,3.9-3.5,6.6c-3.3,5.3-4.7,5.3-6.6,9.4c-1.7,3.8-3.3,9.3-8.5,9.7
        c-0.7,0.1-1.5,0-2.2-0.1c-1.7-0.2-3.5-0.5-5.2-0.7c-3.6-0.5-7.2-0.4-10.7-1.3c-1.9-0.5-3.9-1.1-5.4-2.4c-3.1-2.6-4-7.7-7.8-9.1
        c-4.3-1.6-10.9,2.7-14-2.3c-2.4-3.8,0.4-9.5-5.6-10.2c-1.9-0.2-3.8,0.1-5.7-0.3c-1.4-0.3-2.7-1-4.1-1.2c-1.2-0.2-2.4-0.1-3.7,0.1
        c-3.1,0.3-9.3,1.7-12.1,0.4c-2.2-1-2.6-4.7-3.9-6.6c-1.9-2.8-2.8-1.9-5.6-5.2c-2.6-3.1-1.9-3.9-4.5-6.6c-1.5-1.5-2.4-2-2.8-3.5
        c-0.3-1.3,0.1-2.7,0.2-4.1c-4.3-1.7-9,0.8-13.6,0.6c-1.2-0.1-2.3-0.3-3.5-0.3c-1.6,0-3.1,0.4-4.7,0.8c-3.8,1-7.7,1.6-11.6,2
        c-3.2,0.3-8.8,1.3-11.9,0.2c-1.7-0.6-3-2.3-4.6-3.3c-2.4-1.4-4.7-2.8-7.3-4c-3.7-1.7-4.1-1.6-5.9-2.8c-3.4-2.2-3.3-3.5-7-6.3
        c-1.6-1.2-4.1-3.1-7.7-4.2c-2.6-0.8-2.7-0.3-5.9-1c-4.6-1-8.5-5.1-13.5-4.3c-0.5,0.1-1.1,0.2-1.5,0c-1-0.4-1.1-1.9-2-2.6
        c-1-0.9-2.5-0.4-3.8-0.5c-0.2,0-0.5-0.1-0.6-0.2c-0.1-0.1-0.2-0.4-0.2-0.6c-0.1-0.6,0-1.1,0.1-1.7c0.1-0.7,0.4-1.3,0.4-2
        c-0.1-1.9-1.6-1.7-2.8-2.3c-1.1-0.5-2.1-1.6-3.2-2.3c-3.4-2.1-4.6-1.7-6.9-3.1c-1-0.6-1.6-1.4-2.3-2.2c-1.4-1.5-3-4.5-5-4.8
        c-2.2-0.3-4.4-0.7-6.7-1c-1.8-0.3-3.5-0.5-5.3-0.5c-1.5,0.1-3,0.4-4.4,0.3c-2-0.1-3.8-0.9-5.8-1.1c-1.7-0.2-3.4,0-5.1,0.2
        c-3.2,0.4-6.5,0.8-9.4,2.2c-1,0.5-1.9,1.1-2.9,1.4c-2.3,0.8-5,0.3-6.9-1.3c-0.6-0.5-1.1-1.1-1.7-1.6c-1.9-1.3-4.5-0.9-6.8-0.4
        s-4.6,1-6.9,1.5c-0.6-1.1-1.2-2.2-1.7-3.3c-1.4-2.6-2.9-5.4-5.6-6.7c-0.5-0.2-1-0.4-1.4-0.8c-0.4-0.4-0.7-0.9-1-1.4
        c-2-3.7-5.9-6.3-10-6.9"/>
    <path id="Layer30" class="st0" d="M1624.8,818.8c-0.8-0.9-2.3-2.5-4.4-2.7c-0.7-0.1-1.4,0-3.9,0.9c-3.4,1.1-3.7,1.4-6.1,2.2
        c-3,1-4.6,1.4-6.1,1c-1-0.2-1.4-0.6-2-0.3c-1.3,0.6-0.5,2.9-2,4.1c-0.7,0.6-1.2,0.3-2.9,0.7c-1.9,0.5-3,1.3-3.9,1.9
        c-4.2,2.6-8.1,1.3-8.4,2.6c-0.1,0.7,1,1.1,4.2,3.6c2.6,2.1,2.5,2.3,5.3,4.4c1.8,1.4,2.8,2.2,4.4,3c2.6,1.4,3,1.1,4.4,2.2
        c0.4,0.3,3.3,2.6,3,5.3c-0.1,1.6-1.2,1.7-2.2,3.9c-1.5,3.2-1,7.2,0,7.5c0.6,0.2,0.9-0.9,2.5-1.7c1.9-0.9,2.7,0.1,4.4-0.6
        c1.8-0.7,1.4-1.9,3.9-3.9c1.1-0.9,1-0.5,3.3-1.9c3-1.9,3-2.4,4.4-2.8c1.7-0.4,2.1,0.2,3.9-0.3c1.4-0.4,2.2-1.1,3.3-1.9
        c3.8-2.8,5-2.2,7.2-4.2c1.2-1.1,3.7-3.3,3.6-6.4c-0.1-2-1.3-3.5-1.9-4.2"/>
    <path id="Layer31" class="st0" d="M1637,831.9c1-3.9,1-7.9,0-11.9c0-1,2-3,2-4s0-2,0-3c-1-2-5-3-5-6c1-11-4-19-8-28
        c-6-12,8-18,17-23c12-1,23-9,25-22c1-2,4-2,5-3c0-3,1-5,2-8c1-2,4-2,8-3c9-1,18-5,27-7c1,0,2-1,2-2c0-5.2,3.6-11.5,8.3-13.8
        c2.3-1.1,4.9-1.8,7.1-3.2c2-1.3,3.7-3.1,5.7-4.4c1.4-0.9,3-1.6,4.4-2.5c1.4-1,2.6-2.4,2.8-4c0.1-0.7-0.1-1.5,0.3-2.2
        c0.3-0.6,1-0.9,1.7-1.2c6-2.3,10.9-4,10.5-11.4c-0.4-6.9-4.4-13-6.8-19.3c0-2.5,0.4-2.7,2.3-4.4c1.7-1.5,3.4-3.2,4.9-5
        c0.6-0.7,1.1-1.4,1.1-2.3c0-0.6-0.4-1.1-0.7-1.7c-1.9-3-3.6-6.2-5-9.5c2.6-0.6,5.1-1.9,7.1-3.7c0.8-0.7,1.4-1.8,2.4-1.9
        c1.2-0.1,2.5,1.4,3.6,1.8c1.4,0.5,2.9,0,4.2-0.8s2.1-2,3-3.1"/>
    <path id="Layer32" class="st0" d="M1767.1,622.5c5.3-5,9.9-7.6,13.2-9c3.7-1.7,6.3-2.1,9-4.9c1.1-1.1,2.2-2.6,4.4-3.5
        c1.6-0.6,2-0.2,4.2-0.9c2.4-0.8,2.6-1.5,4.6-2.1c2.8-0.8,3.2,0.3,5.1-0.5c2.6-1,2.2-3.2,5.8-6c1.9-1.4,2.2-1,3.9-2.5
        c1-0.9,1.9-2.1,3.7-4.4c1.7-2.2,2.5-3.2,2.8-3.9c0.9-2.2,0.4-3.2,0.9-6c0.1-0.3,0.6-3.2,2.3-6c0.4-0.6,1.6-2.6,6.2-6.2
        c6-4.7,8.5-5,8.8-7.3c0.3-2.5-2.6-3.6-2.1-6.2c0.4-1.8,1.9-2.1,4.1-4.5c3-3,2.2-4.3,4.8-7.6c3-3.8,4.2-2.4,8.6-6.9
        c3.8-3.9,5.9-7.6,5.9-7.6c1.2-2.1,1.6-3.3,3.1-4.8c2.1-2,3.7-1.9,5.5-3.1c3.9-2.5,2.1-6.5,5.5-12.4c0.7-1.3,3.9-4.2,10.3-10
        c3.6-3.3,9.3-6.7,10.2-11.8c0.4-2.4,0.4-4.3,1.7-6.4c1.2-2,3-3.5,3.6-5.9c0.7-2.8-0.2-4,1-6.2c1.1-2,2.2-1.9,4.1-3.8
        c2.5-2.5,3.3-5.4,4.1-8.6c1.6-5.8-0.1-6.6,1.7-9.3c1.7-2.5,3.7-2.6,5.2-5.9c0.7-1.5,0.6-2.1,1-3.8c0.7-3.2,3.2-5.8,5.5-7.9
        c2.9-2.6,5.4-6.1,9.4-7.2c1.3-0.4,2.7-0.5,4-0.7c4.1-0.8,8.2-3.5,12.4-3.6c4.5,0,8.6,1.7,13.3,1.2c0.8-0.1,1.6-0.2,2.1-0.8
        c0.5-0.4,0.7-1,0.9-1.6c1.3-2.8,3.8-4.9,6.8-5.6c2.9-0.8,6.2-0.1,8.7,1.6c0.7,0.5,1.4,1.1,2.2,1.4c2.6,0.8,4.7-1.9,7.2-3.1
        c2.3-1.1,5.2-0.9,7.1-2.5c1.1-0.9,1.7-2.2,2.6-3.2c1.5-1.7,3.8-2.4,6-3.2c15.2-4.9,30.5-9.9,45.7-14.8"/>
        </g>
        <circle id="lomaxCar" cx="0" cy="0" r="10" fill="deeppink"/>
        <g id="Stops">
            <g id="Stop1">
                <polygon class="st14" points="401.5,1409 405.4,1417.1 414.3,1418.3 407.9,1424.6 409.4,1433.4 401.5,1429.3 393.5,1433.4 
                    395,1424.6 388.6,1418.3 397.5,1417.1        "/>
            </g>
            <g id="Stop2">
                <polygon class="st14" points="377.8,1177.6 381.8,1185.6 390.7,1186.9 384.2,1193.1 385.8,1202 377.8,1197.8 369.9,1202 
                    371.4,1193.1 365,1186.9 373.9,1185.6        "/>
            </g>
            <g id="Stop3">
                <polygon class="st14" points="574.7,1250.3 578.7,1258.3 587.5,1259.6 581.1,1265.8 582.6,1274.6 574.7,1270.5 566.8,1274.6 
                    568.3,1265.8 561.9,1259.6 570.7,1258.3      "/>
            </g>
            <g id="Stop4">
                <polygon class="st14" points="553,1321.4 557,1329.4 565.8,1330.7 559.4,1336.9 560.9,1345.7 553,1341.6 545.1,1345.7 
                    546.6,1336.9 540.2,1330.7 549,1329.4        "/>
            </g>
            <g id="Stop5">
                <polygon class="st14" points="553.7,1291.3 557.7,1299.3 566.5,1300.6 560.1,1306.8 561.6,1315.6 553.7,1311.5 545.8,1315.6 
                    547.3,1306.8 540.9,1300.6 549.7,1299.3      "/>
            </g>
            <g id="Stop6">
                <polygon class="st14" points="545.3,1262.6 549.3,1270.6 558.1,1271.9 551.7,1278.1 553.2,1287 545.3,1282.8 537.4,1287 
                    538.9,1278.1 532.5,1271.9 541.4,1270.6      "/>
            </g>
            <g id="Stop7">
                <polygon class="st14" points="344.4,1600.4 348.4,1608.4 357.2,1609.7 350.8,1615.9 352.3,1624.7 344.4,1620.6 336.5,1624.7 
                    338,1615.9 331.6,1609.7 340.4,1608.4        "/>
            </g>
            <g id="Stop8">
                <polygon class="st14" points="302.7,1464 306.7,1472.1 315.6,1473.4 309.2,1479.6 310.7,1488.4 302.7,1484.3 294.8,1488.4 
                    296.3,1479.6 289.9,1473.4 298.8,1472.1      "/>
            </g>
            <g id="Stop9">
                <polygon class="st14" points="330.5,1475.2 334.5,1483.3 343.3,1484.5 336.9,1490.8 338.4,1499.6 330.5,1495.5 322.6,1499.6 
                    324.1,1490.8 317.7,1484.5 326.6,1483.3      "/>
            </g>
            <g id="Stop11">
                <polygon class="st14" points="330.1,1437.7 334.1,1445.7 342.9,1447 336.5,1453.2 338,1462.1 330.1,1457.9 322.2,1462.1 
                    323.7,1453.2 317.3,1447 326.2,1445.7        "/>
            </g>
            <g id="Stop12">
                <polygon class="st14" points="269.2,1213.2 273.2,1221.2 282,1222.5 275.6,1228.7 277.1,1237.5 269.2,1233.4 261.3,1237.5 
                    262.8,1228.7 256.4,1222.5 265.3,1221.2      "/>
            </g>
            <g id="Stop13">
                <polygon class="st14" points="252.8,1212.4 256.8,1220.4 265.6,1221.7 259.2,1228 260.7,1236.8 252.8,1232.6 244.9,1236.8 
                    246.4,1228 240,1221.7 248.8,1220.4      "/>
            </g>
            <g id="Stop14">
                <polygon class="st14" points="241,1204.9 244.9,1212.9 253.8,1214.2 247.4,1220.5 248.9,1229.3 241,1225.1 233,1229.3 
                    234.6,1220.5 228.1,1214.2 237,1212.9        "/>
            </g>
            <g id="Stop15">
                <polygon class="st14" points="327.6,1008.1 331.6,1016.2 340.4,1017.4 334,1023.7 335.5,1032.5 327.6,1028.4 319.7,1032.5 
                    321.2,1023.7 314.8,1017.4 323.7,1016.2      "/>
            </g>
            <g id="Stop16">
                <polygon class="st14" points="407.5,1149.2 411.4,1157.3 420.3,1158.5 413.9,1164.8 415.4,1173.6 407.5,1169.5 399.6,1173.6 
                    401.1,1164.8 394.7,1158.5 403.5,1157.3      "/>
            </g>
            <g id="Stop17">
                <polygon class="st14" points="568.3,1152.9 572.3,1161 581.2,1162.2 574.8,1168.5 576.3,1177.3 568.3,1173.1 560.4,1177.3 
                    561.9,1168.5 555.5,1162.2 564.4,1161        "/>
            </g>
            <g id="Stop18">
                <polygon class="st14" points="737.5,1169.9 741.5,1177.9 750.3,1179.2 743.9,1185.5 745.4,1194.3 737.5,1190.1 729.6,1194.3 
                    731.1,1185.5 724.7,1179.2 733.5,1177.9      "/>
            </g>
            <g id="Stop19">
                <polygon class="st14" points="723.8,1138.7 727.8,1146.7 736.6,1148 730.2,1154.2 731.7,1163.1 723.8,1158.9 715.9,1163.1 
                    717.4,1154.2 711,1148 719.8,1146.7      "/>
            </g>
            <g id="Stop20">
                <polygon class="st14" points="748.8,1144.3 752.8,1152.3 761.6,1153.6 755.2,1159.9 756.7,1168.7 748.8,1164.5 740.9,1168.7 
                    742.4,1159.9 736,1153.6 744.8,1152.3        "/>
            </g>
            <g id="Stop23">
                <polygon class="st14" points="917.7,855.4 921.6,863.4 930.5,864.7 924.1,871 925.6,879.8 917.7,875.6 909.7,879.8 911.3,871 
                    904.9,864.7 913.7,863.4         "/>
            </g>
            <g id="Stop24">
                <polygon class="st14" points="944.7,891.6 948.7,899.6 957.5,900.9 951.1,907.1 952.6,916 944.7,911.8 936.8,916 938.3,907.1 
                    931.9,900.9 940.8,899.6         "/>
            </g>
            <g id="Stop25">
                <polygon class="st14" points="1004.9,871.1 1008.8,879.1 1017.7,880.4 1011.3,886.6 1012.8,895.5 1004.9,891.3 996.9,895.5 
                    998.5,886.6 992,880.4 1000.9,879.1      "/>
            </g>
            <g id="Stop26">
                <polygon class="st14" points="1190.2,1008.5 1194.1,1016.5 1203,1017.8 1196.6,1024.1 1198.1,1032.9 1190.2,1028.7 1182.3,1032.9 
                    1183.8,1024.1 1177.4,1017.8 1186.2,1016.5       "/>
            </g>
            <g id="Stop27">
                <polygon class="st14" points="1652.8,1293.6 1656.7,1301.6 1665.6,1302.9 1659.2,1309.2 1660.7,1318 1652.8,1313.8 1644.8,1318 
                    1646.3,1309.2 1639.9,1302.9 1648.8,1301.6       "/>
            </g>
            <g id="Stop28">
                <polygon class="st14" points="1684.9,1252.2 1688.8,1260.2 1697.7,1261.5 1691.3,1267.7 1692.8,1276.6 1684.9,1272.4 
                    1676.9,1276.6 1678.4,1267.7 1672,1261.5 1680.9,1260.2       "/>
            </g>
            <g id="Stop29">
                <polygon class="st14" points="1939.5,893.9 1943.4,901.9 1952.3,903.2 1945.9,909.4 1947.4,918.2 1939.5,914.1 1931.5,918.2 
                    1933.1,909.4 1926.7,903.2 1935.5,901.9      "/>
            </g>
            <g id="Stop30">
                <polygon class="st14" points="1619.6,804.7 1623.5,812.8 1632.4,814.1 1626,820.3 1627.5,829.1 1619.6,825 1611.6,829.1 
                    1613.2,820.3 1606.7,814.1 1615.6,812.8      "/>
            </g>
            <g id="Stop31">
                <polygon class="st14" points="1638.6,819.9 1642.5,827.9 1651.4,829.2 1645,835.4 1646.5,844.3 1638.6,840.1 1630.6,844.3 
                    1632.2,835.4 1625.7,829.2 1634.6,827.9      "/>
            </g>
            <g id="Stop32">
                <polygon class="st14" points="1768.7,605.7 1772.6,613.8 1781.5,615 1775.1,621.3 1776.6,630.1 1768.7,626 1760.7,630.1 
                    1762.2,621.3 1755.8,615 1764.7,613.8        "/>
            </g>
            <g id="Stop33">
                <polygon class="st14" points="2055.7,370.9 2059.7,378.9 2068.5,380.2 2062.1,386.4 2063.6,395.3 2055.7,391.1 2047.8,395.3 
                    2049.3,386.4 2042.9,380.2 2051.8,378.9      "/>
            </g>
        </g>
    
    </svg>
    <template v-if="!playedOnce">
      <div id="mapModal">
        <button v-on:click="playMap">Click to start your journey</button>
      </div>
    </template>
    <template v-if="playAgain">
      <button v-on:click="playMap" id="playAgain">Again? Again!</button>
    </template>
  </div>
</template>

<script>
import * as d3 from 'd3'
import annotation from 'd3-svg-annotation'
import {annotationObject, removalMap} from '../annotations'

export default {
  name: 'MapContainer',
  data () {
    return {
      t: d3.transition(),
      playedOnce: false,
      playAgain: false
    }
  },
  methods: {
    playMap: function () {
      this.resetMap()
      if (!this.playedOnce) {
        this.playedOnce = !this.playedOnce
      } else {
        this.playAgain = false
      }
      this.animateLine(1)
    },
    animateLine: function (number) {
      // show location marker
      const thisStop = document.querySelector(`#Stop${number}`)
      if (thisStop !== null) {
        thisStop.style.display = null
      }

      if (removalMap.hasOwnProperty(`Stop${number}`)) {
        for (let i = 0; i < removalMap[`Stop${number}`].length; i++) {
          d3.select(`#annotation-group-${removalMap[`Stop${number}`][i]}`)
            .transition()
            .ease(d3.easeLinear)
            .duration(250)
            .style('opacity', '0')
        }
      }

      d3.select(`#annotation-group-Stop${number}`)
        .transition()
        .ease(d3.easeLinear)
        .duration(750)
        .style('opacity', '1')

      // just break out of the chain if we've reached Washington, DC
      if (number === 33) {
        window.setTimeout(() => {
          d3.select('#annotation-group-Stop33')
            .transition()
            .ease(d3.easeLinear)
            .duration(750)
            .style('opacity', '0')
          this.playAgain = true
        }, 2500)
        return
      }

      const pathLength = document.querySelector(`#Layer${number}`).getTotalLength()

      this.t = d3.transition()
        .duration(pathLength * 20)
        .ease(d3.easeLinear)
        .on('end', () => {
          if (this.t !== null) {
            d3.select(`#Layer${number}`).style('stroke', '#f47cbc')
            this.animateLine(number + 1)
          }
        })

      d3.select(`#Layer${number}`)
        .style('stroke', 'deeppink')
        .style('stroke-dasharray', pathLength)
        .style('stroke-dashoffset', pathLength)
        .transition(this.t)
        .style('stroke-dashoffset', 0)

      d3.select('#lomaxCar')
        .transition(this.t)
        .attrTween('cx', function () {
          var interpolate = d3.interpolateNumber(0, pathLength)
          return function (t) {
            return document.getElementById(`Layer${number}`).getPointAtLength(interpolate(t)).x
          }
        })
        .attrTween('cy', function () {
          var interpolate = d3.interpolateNumber(0, pathLength)
          return function (t) {
            return document.getElementById(`Layer${number}`).getPointAtLength(interpolate(t)).y
          }
        })
    },
    resetMap: function () {
      // turn off all the location markers
      this.t = null
      const allStops = document.querySelector('#Stops').children
      for (let i = 0; i < allStops.length; i++) {
        allStops[i].style.display = 'none'
      }

      const children = document.querySelectorAll('#allRoads path')
      for (let i = 0; i < children.length; i++) {
        children[i].style.stroke = 'none'
      }

      d3.select('#lomaxCar')
        .attr('cx', function () { return document.getElementById('Layer1').getPointAtLength(0).x })
        .attr('cy', function () { return document.getElementById('Layer1').getPointAtLength(0).y })
    }
  },
  mounted: function () {
    this.resetMap()

    for (let i = 0; i < annotationObject.length; i++) {
      const makeAnnotations = annotation.annotation()
        .type(annotation.annotationCalloutCircle)
        .accessors({
          x: d => {
            let avgX = 0
            for (let i = 0; i < d.stops.length; i++) {
              avgX = avgX + document.querySelector(`#${d.stops[i]}`).getBBox().x + (document.querySelector(`#${d.stops[i]}`).getBBox().width / 2)
            }
            return d.x
            // return avgX / d.stops.length
          },
          y: d => {
            let avgY = 0
            for (let i = 0; i < d.stops.length; i++) {
              avgY = avgY + document.querySelector(`#${d.stops[i]}`).getBBox().y + (document.querySelector(`#${d.stops[i]}`).getBBox().height / 2)
            }
            return d.y
            // return avgY / d.stops.length
          }
        })
        .annotations(annotationObject[i])

      d3.select(this.$el.children[0])
        .append('g')
        .attr('id', `annotation-group-${annotationObject[i][0].data.stops[0]}`)
        .style('opacity', '0')
        .call(makeAnnotations)
    }
  }
}
</script>
<style>
.annotation-note-title{
  font-size: 52px;
  font-family: 'Alfa Slab One', cursive;
  font-weight: normal;
  fill: deeppink;
}
.annotation-note-label{
  font-size: 48px;
  font-family: 'Georgia';
  fill: white;
}
.annotation-note-bg{
  fill: #141e30;
  fill-opacity:1;
}
.annotation path{
  stroke: #141e30;
  stroke-width: 10px;
}
</style>
<style scoped>
a{
  color: deeppink;
  font-family: 'Georgia';
}
a:visited{
  color: white;
}
a:hover{
  color: #f47cbc;
}
#mapContainer{
  width: 95%;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
}

@media only screen and (max-device-width: 750px) and (min-device-width: 320px){
  #mapContainer #mapModal{
    height: 60%;
    top: 20%;
  }
  #mapContainer #mapModal button{
    width: 90%;
  }
}



h2{
  color: deeppink;
  font-family: 'Alfa Slab One', cursive;
  font-size: 30px;
}

p{
  color: white;
  font-family: 'Georgia';
  font-size: 18px;
  line-height: 1.2;
  width: 85%;
  margin-right: auto;
  margin-left: auto;
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: center;
}

#mapModal{
  background-color: rgb(20,30,48,0.8);
  padding: 20px;
  position: absolute;
  height: 25%;
  top: 37.5%;
  right: 10%;
  width: 80%;
}

#mapModal button{
  margin: auto;
  width: 50%;
  height: 100%;
  padding: 20px;
  font-size: 22px;
  font-family: 'Alfa Slab One', cursive;
  cursor: pointer;
  color: deeppink;
  background: #141e30;
  display: block;

}

#mapModal button:hover{
  color: #141e30;
  background: deeppink;
}

#playAgain{
  position: absolute;
  padding: 20px;
  font-size: 22px;
  font-family: 'Alfa Slab One', cursive;
  color: deeppink;
  cursor: pointer;
  background: #141e30;
  bottom: 0;
  width: 50%;
  right: 25%;
}

#playAgain:hover{
  color: #141e30;
  background: deeppink;
}

#Layer_1{
  width: 100%;
}
.st0{
  fill:none;
  stroke-width:5;
  stroke-miterlimit:10;
}
.st1{fill:none;stroke:#000000;stroke-width:7.2263;stroke-miterlimit:10;}
.st2{fill:#141e30;}
.st3{fill:#FF4BFA;}
.st4{font-family: 'Georgia';}
.st5{font-size:59px;}
.st6{display:none;}
.st7{display:inline;stroke:#000000;stroke-width:6.5711;stroke-miterlimit:10;}
.st8{display:inline;fill:none;}
.st9{display:inline;}
.st10{font-size:40px;}
.st11{display:inline;fill:none;stroke:#000000;stroke-width:6.5711;stroke-miterlimit:10;}
.st12{display:inline;fill:none;stroke:#000000;stroke-width:7.2277;stroke-miterlimit:10;}
.st13{font-size:43.8075px;}
.st14{
  fill: #141e30; 
  stroke: white;
}
</style>



// WEBPACK FOOTER //
// src/components/MapContainer.vue